import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import FloatingWhatsapp from "@/components/site/FloatingWhatsapp";
import FloatingBookCta from "@/components/site/FloatingBookCta";
import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import Daktylios from "@/pages/Daktylios";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";

// Scroll to top on route change so /checkout doesn't inherit a deep scroll.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// In-page anchor scroll for hash links (only used on the home page).
const HashScroller = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (pathname !== "/" || !hash || hash.length < 2) return;
    const id = decodeURIComponent(hash.slice(1));
    const tries = [100, 700];
    const timers = tries.map((delay) =>
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "auto", block: "start" });
      }, delay)
    );
    return () => timers.forEach(clearTimeout);
  }, [pathname, hash]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <Nav />
      {children}
      <Footer />
      <FloatingWhatsapp />
      <FloatingBookCta />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <HashScroller />
      <div className="App" data-testid="app-root">
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/daktylios" element={<Daktylios />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Chrome>
      </div>
    </BrowserRouter>
  );
}

export default App;
